import { SevenroomsAudience as SevenroomsAudienceModel } from '@models/venue/integrations/SevenroomsAudience'
import { useAppSelector } from '@store/hooks'
import { selectSevenroomsAudienceById } from '@store/venue/integrations/SevenroomsAudienceReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Space, Tag } from 'antd'
import { FC } from 'react'

type Props = SBModelComponent<SevenroomsAudienceModel> & {}

const SevenroomsAudienceOption: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectSevenroomsAudienceById(id!))

  if (!item) {
    return <></>
  }

  return (
    <Space>
      {item.name} {item.isGlobal && <Tag>Global</Tag>}{' '}
      {item.isDefault && <Tag color="red">Default</Tag>}
    </Space>
  )
}

type SevenroomsAudienceOptionType = { Option: typeof SevenroomsAudienceOption }

export { SevenroomsAudienceOption, type SevenroomsAudienceOptionType }
